<template>
  <div class="page">
    <div class="header">
      <a href="/" target="_self" title="logo"
        ><img src="@/assets/images/hsk_mock_logo.png" alt=""
      /></a>
    </div>
    <div class="container-box">
      <p class="title">验证模拟证书</p>
      <h2 class="title-trans">Verify Mock Certificate</h2>
      <div class="content">
        <div class="number">
          <div class="flex">
            <div class="desc-1">编号 Certificate No.</div>
            <div class="desc-2">{{ number }}</div>
          </div>
        </div>
        <div class="report">HSK( {{ report }})模拟测试报告</div>
        <div class="name">
          <div class="flex">
            <div class="desc-1">姓名 Name</div>
            <div class="desc-2">{{ name }}</div>
          </div>
        </div>
        <div class="gender">
          <div class="flex">
            <div class="desc-1">性别 Gender</div>
            <div class="desc-2">{{ gender }}</div>
          </div>
        </div>
        <div class="nationality">
          <div class="flex">
            <div class="desc-1">国籍 Nationality</div>
            <div class="desc-2">{{ nationality }}</div>
          </div>
        </div>
        <div class="time">
          <div class="flex">
            <div class="desc-1">模考时间 Mock date</div>
            <div class="desc-2">{{ time }}</div>
          </div>
        </div>
        <div class="total">
          <div class="flex">
            <div class="desc-1" v-if="isShowTotal">总分 Total score</div>
            <div class="desc-2">{{ total }}</div>
          </div>
        </div>
        <div class="liston" v-if="isShowListen">
          <div class="flex">
            <div class="desc-1">听力 Listening score</div>
            <div class="desc-2">{{ liston }}</div>
          </div>
        </div>
        <div class="read" v-if="isShowRead">
          <div class="flex">
            <div class="desc-1">阅读 Reading score</div>
            <div class="desc-2">{{ read }}</div>
          </div>
        </div>
        <div class="write" v-if="isShowWrite">
          <div class="flex">
            <div class="desc-1">书写 writing score</div>
            <div class="desc-2">{{ write }}</div>
          </div>
        </div>
        <div class="translation" v-if="isShowTranslation">
          <div class="flex">
            <div class="desc-1">翻译 translation score</div>
            <div class="desc-2">{{ translation }}</div>
          </div>
        </div>
        <div class="speaking" v-if="isShowSpeaking">
          <div class="flex">
            <div class="desc-1">口语 speaking score</div>
            <div class="desc-2">{{ speaking }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      number: '/',
      report: '/',
      name: '/',
      gender: '/',
      nationality: '/',
      time: '/',
      total: '/',
      liston: '/',
      read: '/',
      write: '/',
      translation: '/',
      speaking: '/',
      isShowListen: false,
      isShowRead: false,
      isShowTotal: false,
      isShowWrite: false,
      isShowTranslation: false,
      isShowSpeaking: false,
    }
  },
  mounted() {
    this.fetchScanData()
  },
  methods: {
    fetchScanData() {
      window.utilV2.getData(window.ApiPath.get_certificate_details, this.$route.params, (data) => {
        const {
          country_name,
          family_name,
          given_name,
          gender,
          cert_code,
          level_name,
          user_total_score,
          user_listen_score,
          user_read_score,
          user_write_score,
          user_translation_score,
          user_speaking_score,
          exam_listen_score,
          exam_read_score,
          exam_total_score,
          exam_write_score,
          exam_translation_score,
          exam_speaking_score,
          year,
          month,
          day,
        } = data
        this.number = cert_code
        this.report = level_name
        this.name = `${given_name} ${family_name}`
        this.gender = gender || '未知'
        this.nationality = country_name
        this.time = `${year}-${month}-${day}`
        this.total = Math.round(Number(user_total_score))
        this.liston = Math.round(Number(user_listen_score))
        this.read = Math.round(Number(user_read_score))
        this.write = Math.round(Number(user_write_score))
        this.translation = Math.round(Number(user_translation_score))
        this.speaking = Math.round(Number(user_speaking_score))
        this.isShowListen = !!exam_listen_score
        this.isShowRead = !!exam_read_score
        this.isShowTotal = !!exam_total_score
        this.isShowWrite = !!exam_write_score
        this.isShowTranslation = !!exam_translation_score
        this.isShowSpeaking = !!exam_speaking_score
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  overflow: scroll;
  .header {
    position: fixed;
    width: 100%;
    height: 60px;
    background: #2c2f46;
    display: flex;
    align-items: center;
    padding: 0 17px;
    top: 0;
  }
  .container-box {
    padding: 26px 24px;
    margin-top: 60px;
    .title {
      font-family: 'FZFengYaSongS-GB';
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      color: #2c2f46;
      margin-bottom: 2px;
    }
    .title-trans {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #2c2f46;
      margin-bottom: 6px;
    }
    .desc-1 {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #b5b5be;
      margin-top: 20px;
    }
    .desc-2 {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 16px;
      color: #000000;
      width: 100%;
      margin-top: 4px;
      padding-bottom: 7px;
      border-bottom: 1px solid #696974;
    }
    .report {
      margin-top: 40px;
      margin-bottom: 20px;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #2c2f46;
    }
    .flex {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
